<div class="db-revamp">
  <!-- Page header (breadcrumb now lives in the shared topbar — see
       HeaderComponent — driven by each route's data.title) -->
  <div class="pg-header">
    <div class="pg-header__crumbs">
      <h1 class="pg-title">Dashboard</h1>
    </div>
    <!-- Chart view / World view switcher -->
    <div class="pg-header__actions db">
      <button type="button" class="pg-icon-btn" title="World view" [class.active]="viewMode === 'world'" (click)="setViewMode('world')">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14 7C14 6.10986 13.8362 5.25097 13.5085 4.42333C13.1527 3.5247 12.6332 2.73367 11.9498 2.05025C11.2663 1.36684 10.4753 0.847247 9.57663 0.491483C8.749 0.163828 7.89012 9.12921e-07 7 0C6.10986 0 5.25097 0.163827 4.42333 0.491483C3.5247 0.847247 2.73367 1.36684 2.05025 2.05025C1.36684 2.73367 0.847247 3.5247 0.491482 4.42333C0.163827 5.25097 0 6.10986 0 7C0 7.89012 0.163827 8.749 0.491482 9.57663C0.847247 10.4753 1.36684 11.2663 2.05025 11.9498C2.73367 12.6332 3.5247 13.1527 4.42333 13.5085C5.25097 13.8362 6.10986 14 7 14C7.89012 14 8.749 13.8362 9.57663 13.5085C10.4753 13.1527 11.2663 12.6332 11.9498 11.9498C12.6332 11.2663 13.1527 10.4753 13.5085 9.57663C13.8362 8.749 14 7.89012 14 7ZM7 1.07692C7.05913 1.07692 7.11809 1.07778 7.17689 1.07948L5.97024 2.28617C5.82807 2.42834 5.75567 2.50131 5.72962 2.58345C5.70718 2.65417 5.70718 2.73045 5.72962 2.80115C5.75567 2.88331 5.82807 2.95628 5.97024 3.09844L6.30457 3.43278C6.42874 3.55695 6.4912 3.6195 6.53554 3.692C6.57464 3.75592 6.6035 3.82559 6.62105 3.89843C6.64096 3.98105 6.64103 4.06944 6.64103 4.24505V5.08829C6.64103 5.2639 6.64096 5.35229 6.62105 5.4349C6.6035 5.50775 6.57464 5.57742 6.53554 5.64134C6.4912 5.71383 6.42874 5.77639 6.30457 5.90055L5.43178 6.77335C5.28961 6.91552 5.21664 6.98791 5.13449 7.014C5.06378 7.0364 4.9875 7.0364 4.91679 7.014C4.83464 6.98791 4.76167 6.91552 4.61951 6.77335L1.87483 4.02868C2.13081 3.58603 2.44311 3.18039 2.81175 2.81175C3.39003 2.23348 4.05936 1.79382 4.81975 1.49279C5.52006 1.21555 6.24681 1.07692 7 1.07692ZM11.1882 11.1882C11.7491 10.6274 12.1795 9.98093 12.4796 9.24882L11.274 8.04321C11.1609 7.93009 11.1037 7.87311 11.0386 7.83132C10.967 7.78554 10.8879 7.75278 10.805 7.73458C10.7294 7.71799 10.6488 7.71792 10.4887 7.71792H8.89595C8.73593 7.71792 8.65522 7.71799 8.57962 7.73458C8.49667 7.75278 8.41757 7.78554 8.34603 7.83132C8.28086 7.87311 8.22374 7.93009 8.11062 8.04321L7.39263 8.7612C7.2632 8.89063 7.19705 8.95741 7.17031 9.03098C7.14147 9.11022 7.14147 9.19751 7.17031 9.27668C7.19705 9.35032 7.2632 9.41703 7.39263 9.54653C7.50582 9.65965 7.5628 9.71677 7.60452 9.78194C7.65037 9.85341 7.68313 9.93258 7.70133 10.0155C7.71785 10.0911 7.71792 10.1718 7.71792 10.3318V12.8801C8.21753 12.8197 8.70497 12.6953 9.18022 12.5072C9.94061 12.2062 10.6099 11.7665 11.1882 11.1882Z"
            fill="#2D2D2D" fill-opacity="0.4" />
        </svg>
      </button>
      <button type="button" class="pg-icon-btn" title="Toggle theme" [class.active]="viewMode === 'chart'" (click)="setViewMode('chart')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.79827 7.20174C8.9136 7.31711 9.07009 7.38193 9.23323 7.38193H15.3848C15.7246 7.38193 16 7.10651 16 6.76677C16 4.89818 15.3393 3.30323 14.018 1.98194C12.6968 0.660647 11.1018 0 9.23323 0C8.8935 0 8.61807 0.275415 8.61807 0.615157V6.76676C8.61807 6.92992 8.68287 7.08638 8.79827 7.20174ZM0.151608 9.88735C-0.147724 8.3825 -0.00380959 6.92131 0.583351 5.50378C1.17051 4.08625 2.10196 2.95128 3.37771 2.09885C4.42381 1.39986 5.55686 0.987458 6.77684 0.861643C7.22744 0.815171 7.5928 1.18744 7.5928 1.64043V7.58698C7.5928 8.03998 7.96003 8.4072 8.41302 8.4072H14.3596C14.8126 8.4072 15.1849 8.7726 15.1384 9.22314C15.0125 10.4431 14.6001 11.5762 13.9012 12.6223C13.0487 13.898 11.9137 14.8295 10.4962 15.4167C9.0787 16.0038 7.6175 16.1477 6.11266 15.8484C4.60782 15.5491 3.31294 14.8569 2.22801 13.772C1.14307 12.687 0.45094 11.3922 0.151608 9.88735Z"
            fill="#2D2D2D" fill-opacity="0.4" />
        </svg>
      </button>
    </div>
  </div>

  <ng-container *ngIf="viewMode === 'chart'; else worldViewTpl">

  <!-- Page-load skeleton, shown until every initial dashboard call has
       settled (see pageLoading in the component) -->
  <ng-container *ngIf="pageLoading; else dashboardContentTpl">
    <div class="db-skeleton">
      <div class="db-stats-grid">
        <div class="placeholder-glow db-card--weather" style="background: transparent;"><span class="placeholder w-100 db-skeleton-card"></span></div>
        <div class="placeholder-glow" *ngFor="let i of [1,2,3,4]"><span class="placeholder w-100 db-skeleton-card"></span></div>
      </div>
      <div class="db-row db-row--split">
        <div class="placeholder-glow"><span class="placeholder w-100 db-skeleton-panel"></span></div>
        <div class="placeholder-glow"><span class="placeholder w-100 db-skeleton-panel"></span></div>
      </div>
      <div class="db-row db-row--triple">
        <div class="placeholder-glow" *ngFor="let i of [1,2,3]"><span class="placeholder w-100 db-skeleton-panel--sm"></span></div>
      </div>
    </div>
  </ng-container>

  <ng-template #dashboardContentTpl>

  <!-- Stat cards -->
  <div class="db-stats-grid">

    <div class="db-card db-card--weather">
      <div class="db-card__head-row">
        <span class="db-card__title">Weather</span>
        <!-- <button type="button" class="db-card__link" title="View more">
          <i class="ri-arrow-right-up-line"></i>
        </button> -->
      </div>
      <div class="db-weather__body">
        <div class="db-weather__main">
          <span class="db-weather__temp">{{ weather.temp }}&deg;C</span>
          <span class="db-weather__date">{{ today | date:'EEE yyyy-MM-dd' }}</span>
        </div>
        <div class="db-weather__icon-group">
          <img class="db-weather__icon" [src]="weather.icon" alt="">
          <span class="db-weather__condition">{{ weather.condition }}</span>
        </div>
      </div>
    </div>

    <div class="db-card" *ngFor="let stat of statCards">
      <div class="db-card__head-row">
        <div class="db-thunder-stage">
          <div class="db-thunder-particle" style="--dx:44px; --dy:0px;"></div>
          <div class="db-thunder-particle" style="--dx:38px; --dy:20px;"></div>
          <div class="db-thunder-particle" style="--dx:22px; --dy:37px;"></div>
          <div class="db-thunder-particle" style="--dx:0px; --dy:43px;"></div>
          <div class="db-thunder-particle" style="--dx:-22px; --dy:37px;"></div>
          <div class="db-thunder-particle" style="--dx:-38px; --dy:20px;"></div>
          <div class="db-thunder-particle" style="--dx:-44px; --dy:0px;"></div>
          <div class="db-thunder-particle" style="--dx:-38px; --dy:-20px;"></div>
          <div class="db-thunder-particle" style="--dx:-22px; --dy:-37px;"></div>
          <div class="db-thunder-particle" style="--dx:0px; --dy:-43px;"></div>
          <div class="db-thunder-particle" style="--dx:22px; --dy:-37px;"></div>
          <div class="db-thunder-particle" style="--dx:38px; --dy:-20px;"></div>
          <div class="db-thunder-particle" style="--dx:32px; --dy:32px;"></div>
          <div class="db-thunder-particle" style="--dx:-32px; --dy:-32px;"></div>
          <div class="db-thunder-icon-wrap">
            <img *ngIf="stat.icon; else iconFontTpl" [src]="stat.icon" alt="">
            <ng-template #iconFontTpl>
              <span class="db-card__icon db-card__icon--font">
                <i [class]="stat.iconClass"></i>
              </span>
            </ng-template>
          </div>
        </div>
        <!-- <button type="button" class="db-card__link" title="View more">
          <i class="ri-arrow-right-up-line"></i>
        </button> -->
      </div>
      <div class="db-card__text-group">
        <div class="db-card__value">
          {{ stat.value }} <span class="db-card__unit">{{ stat.unit }}</span>
        </div>
        <div class="db-card__label">{{ stat.label }}</div>
      </div>
    </div>

  </div>

  <!-- Yield statistics + Plant ranking -->
  <div class="db-row db-row--split">

    <div class="db-panel">
      <div class="db-panel__head">
        <h2>Yield Statistics</h2>
        <div class="db-panel__tools">
          <div class="db-toggle">
            <button type="button" [class.active]="yieldRange === 'year'" (click)="setYieldRange('year')">Year</button>
            <button type="button" [class.active]="yieldRange === 'lifetime'"
              (click)="setYieldRange('lifetime')">Lifetime</button>
          </div>
          <div class="db-year-picker" [class.db-year-picker--hidden]="yieldRange !== 'year'">
            <button type="button" (click)="shiftYear(-1)"><i class="ri-arrow-left-s-line"></i></button>
            <!-- <i class="ri-calendar-line"></i>  -->
            <span>{{ selectedYear }}</span> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16"
              viewBox="0 0 14 16" fill="none">
              <path
                d="M10.7092 1.63726V0.547945C10.7092 0.245479 10.4749 0 10.1862 0C9.89749 0 9.66318 0.245479 9.66318 0.547945V1.55397H7.52301V0.547945C7.52301 0.245479 7.2887 0 7 0C6.7113 0 6.47699 0.245479 6.47699 0.547945V1.55397H4.33682V0.547945C4.33682 0.245479 4.10251 0 3.81381 0C3.5251 0 3.2908 0.245479 3.2908 0.547945V1.63726C1.41632 2.02959 0 3.76548 0 5.8411V11.7129C0 14.0778 1.83473 16 4.09205 16H9.90795C12.1653 16 14 14.0778 14 11.7129V5.8411C14 3.76548 12.5837 2.02959 10.7092 1.63726ZM3.2908 2.76603V3.4411C3.2908 3.74356 3.5251 3.98904 3.81381 3.98904C4.10251 3.98904 4.33682 3.74356 4.33682 3.4411V2.64986H6.47699V3.4411C6.47699 3.74356 6.7113 3.98904 7 3.98904C7.2887 3.98904 7.52301 3.74356 7.52301 3.4411V2.64986H9.66318V3.4411C9.66318 3.74356 9.89749 3.98904 10.1862 3.98904C10.4749 3.98904 10.7092 3.74356 10.7092 3.4411V2.76603C11.9163 3.11233 12.8285 4.21699 12.9414 5.56055H1.06067C1.17364 4.21479 2.08368 3.11233 3.2908 2.76603ZM9.90795 14.9041H4.09205C2.41213 14.9041 1.04603 13.4729 1.04603 11.7129V6.65425H12.954V11.7129C12.954 13.4729 11.5879 14.9041 9.90795 14.9041ZM4.96234 8.91616C4.96234 9.38082 4.6046 9.75562 4.16109 9.75562C3.71757 9.75562 3.35983 9.38082 3.35983 8.91616C3.35983 8.45151 3.71757 8.07671 4.16109 8.07671C4.6046 8.0789 4.96234 8.4537 4.96234 8.91616ZM4.96234 12.0548C4.96234 12.5195 4.6046 12.8942 4.16109 12.8942C3.71757 12.8942 3.35983 12.5195 3.35983 12.0548C3.35983 11.5901 3.71757 11.2153 4.16109 11.2153C4.6046 11.2153 4.96234 11.5923 4.96234 12.0548ZM8.48745 8.91616C8.48745 9.38082 8.12971 9.75562 7.68619 9.75562C7.24268 9.75562 6.88494 9.38082 6.88494 8.91616C6.88494 8.45151 7.24268 8.07671 7.68619 8.07671C8.12971 8.07671 8.48745 8.4537 8.48745 8.91616Z"
                fill="#999999" />
            </svg>
            <button type="button" (click)="shiftYear(1)"><i class="ri-arrow-right-s-line"></i></button>
          </div>
        </div>
      </div>
      <div class="db-panel__legend">
        <span class="db-panel__unit">kWh</span>
        <span class="db-panel__legend-item"><span class="db-dot" style="background:#78D18A"></span> Yield</span>
      </div>
      <!-- [isDisabled]="true" isn't an apx-chart input — it's here purely to
      suppress ngx-bootstrap's TooltipDirective, which also matches on the
      generic [tooltip] attribute selector and was rendering our ApexCharts
      tooltip *config object* as its own popup ("[object Object]" on hover). -->
      <div class="db-chart-wrap">
        <apx-chart *ngIf="yieldChart" [series]="yieldChart.series" [chart]="yieldChart.chart"
          [plotOptions]="yieldChart.plotOptions" [dataLabels]="yieldChart.dataLabels" [colors]="yieldChart.colors"
          [grid]="yieldChart.grid" [xaxis]="yieldChart.xaxis" [yaxis]="yieldChart.yaxis"
          [tooltip]="yieldChart.tooltip" [isDisabled]="true">
        </apx-chart>
        <div class="db-chart-loader" *ngIf="yieldLoading">
          <span class="db-spinner"></span>
        </div>
      </div>
    </div>

    <div class="db-panel">
      <div class="db-panel__head">
        <h2>{{ statsView === 'tickets' ? 'Tickets' : 'FSR' }}</h2>
        <div class="db-panel__tools">
          <div class="db-toggle">
            <button type="button" [class.active]="statsView === 'tickets'"
              (click)="setStatsView('tickets')">Tickets</button>
            <button type="button" [class.active]="statsView === 'fsr'" (click)="setStatsView('fsr')">FSR</button>
          </div>
        </div>
      </div>
      <div class="db-panel__legend" style="visibility:hidden">
        <span class="db-panel__unit">tickets</span>
        <span class="db-panel__legend-item"><span class="db-dot"></span> spacer</span>
      </div>
      <apx-chart *ngIf="statsView === 'tickets' && ticketsChart" [series]="ticketsChart.series"
        [chart]="ticketsChart.chart" [plotOptions]="ticketsChart.plotOptions" [dataLabels]="ticketsChart.dataLabels"
        [colors]="ticketsChart.colors" [grid]="ticketsChart.grid" [xaxis]="ticketsChart.xaxis"
        [yaxis]="ticketsChart.yaxis" [tooltip]="ticketsChart.tooltip" [isDisabled]="true">
      </apx-chart>
      <apx-chart *ngIf="statsView === 'fsr' && fsrStatsChart" [series]="fsrStatsChart.series"
        [chart]="fsrStatsChart.chart" [plotOptions]="fsrStatsChart.plotOptions"
        [dataLabels]="fsrStatsChart.dataLabels" [colors]="fsrStatsChart.colors" [grid]="fsrStatsChart.grid"
        [xaxis]="fsrStatsChart.xaxis" [yaxis]="fsrStatsChart.yaxis" [tooltip]="fsrStatsChart.tooltip"
        [isDisabled]="true">
      </apx-chart>
    </div>

  </div>

  <!-- Plant status + Active alarms + Environmental benefits -->
  <div class="db-row db-row--triple">

    <div class="db-panel">
      <div class="db-panel__head">
        <h2>Plant Status</h2>
        <!-- <button type="button" class="db-card__link" title="View more">
          <i class="ri-arrow-right-up-line"></i>
        </button> -->
      </div>
      <div class="db-gauge-wrap db-donut db-donut--half">
        <apx-chart *ngIf="plantStatusChart" [series]="plantStatusChart.series" [chart]="plantStatusChart.chart"
          [labels]="plantStatusChart.labels" [colors]="plantStatusChart.colors" [stroke]="plantStatusChart.stroke" [fill]="plantStatusChart.fill"
          [dataLabels]="plantStatusChart.dataLabels" [legend]="plantStatusChart.legend"
          [plotOptions]="plantStatusChart.plotOptions" [states]="plantStatusChart.states"
          [tooltip]="plantStatusChart.tooltip" [isDisabled]="true">
        </apx-chart>
      </div>
    </div>

    <div class="db-panel">
      <div class="db-panel__head">
        <h2>Active Alarms</h2>
        <!-- <button type="button" class="db-card__link" title="View more">
          <i class="ri-arrow-right-up-line"></i>
        </button> -->
      </div>
      <div class="db-gauge-wrap db-donut">
      <apx-chart *ngIf="alarmsChart" [series]="alarmsChart.series" [chart]="alarmsChart.chart"
        [labels]="alarmsChart.labels" [colors]="alarmsChart.colors" [stroke]="alarmsChart.stroke" [fill]="alarmsChart.fill"
        [dataLabels]="alarmsChart.dataLabels" [legend]="alarmsChart.legend" [plotOptions]="alarmsChart.plotOptions"
        [states]="alarmsChart.states" [tooltip]="alarmsChart.tooltip" [isDisabled]="true">
      </apx-chart>
      </div>
    </div>

    <div class="db-panel db-panel--fill">
      <div class="db-panel__head">
        <h2>Environmental Benefits</h2>
        <!-- <button type="button" class="db-card__link" title="View more">
          <i class="ri-arrow-right-up-line"></i>
        </button> -->
      </div>
      <div class="db-benefits">
        <div class="db-benefit-row" [class.db-benefit-row--reverse]="benefit.reverse"
          [ngStyle]="{ background: benefit.iconBg }" *ngFor="let benefit of environmentalBenefits">
          <div class="db-benefit-row__text">
            <div class="db-benefit-row__value">{{ benefit.value }} <span>{{ benefit.unit }}</span></div>
            <div class="db-benefit-row__label">{{ benefit.label }}</div>
          </div>
          <img class="db-benefit-row__icon" [src]="benefit.icon" alt="">
        </div>
      </div>
    </div>

  </div>

  </ng-template>

  </ng-container>

  <ng-template #worldViewTpl>
    <app-dashboard-map></app-dashboard-map>
  </ng-template>

</div>